import { Spinner } from "@fluentui/react";
import { ErrorMessageComponent } from "../../Error/ErrorMessageComponent";
import SettlementTotalItemComponent from "../SettlementTotalItem/SettlementTotalItem.Component";

// functions
import * as ComponentFunctions from './SettlementTotal.Functions';
import { connect } from "react-redux";

// styles
import './SettlementTotal.Styles.css';

import { SettlementTotal } from "../../../models/Entities/SettlementTotals/SettlementTotals";

const SettlementTotalComponent = (props: ComponentFunctions.Props) => {

    if (props.isLoading) {
        return <Spinner />;
    }

    return (
        <div className="stl-root">
            <div className="stl-header">
                <span className="stl-header-title">Totales generales de la liquidación</span>
                {props.isRecalculating && <Spinner />}
            </div>
            {props.failOnLoading && (props.error || props.entityError) && (
                <ErrorMessageComponent Error={props.error || props.entityError} />
            )}
            <div className="stl-currencies">
                {props.Totals?.map((total: SettlementTotal) => (
                    <SettlementTotalItemComponent
                        key={total.currencyCode}
                        SettlementId={props.SettlementId}
                        CurrencyCode={total.currencyCode}
                    />
                ))}
            </div>
        </div>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(SettlementTotalComponent as any);